// confirm_polyfill.js — lightweight stand-in for Turbo / Rails UJS confirm.
//
// Background: the app historically used Turbo's `data-turbo-confirm` attribute
// on `button_to`/`link_to` to trigger a JS `confirm()` dialog before submit.
// Turbo was removed in T10 (see docs/LCP_OPTIMIZATION_PLAN_2026_07_06.md §3.8)
// because none of Drive / Frames / Streams / ActionCable were actually used,
// and shipping ~93 KB of Turbo just to drive confirm dialogs was not worth it.
//
// This 40-line replacement restores the same UX: any <form> or <button>
// carrying `data-turbo-confirm="…"` (or a wrapping `<form>` with the attribute
// when the inner submit button was clicked) pops a native `confirm()` and
// cancels the submit if the user declines.
//
// Scope:
//   - Handles `<form data-turbo-confirm="…">` — common shape from
//     `button_to …, form: { data: { turbo_confirm: … } }` (rev 5 T9 migrations).
//   - Handles `<button data-turbo-confirm="…">` inside a form.
//   - One capture-phase submit listener on `document`; no per-element wiring.

(function () {
  function confirmMessageFromEvent(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return null;

    // Direct attribute on the form itself.
    if (form.dataset.turboConfirm) return form.dataset.turboConfirm;

    // Attribute on the clicked submit button, if discoverable.
    const submitter = event.submitter;
    if (submitter && submitter.dataset && submitter.dataset.turboConfirm) {
      return submitter.dataset.turboConfirm;
    }

    // Fallback — any submit button inside the form carrying the attribute.
    const btn = form.querySelector('[type="submit"][data-turbo-confirm]');
    return btn ? btn.dataset.turboConfirm : null;
  }

  document.addEventListener("submit", function (event) {
    const message = confirmMessageFromEvent(event);
    if (message && !window.confirm(message)) {
      event.preventDefault();
    }
  }, true); // capture: settle before any normal-phase handlers

  // Plain links (<a>) carrying data-turbo-confirm — covers the rare
  // case of a non-destructive link that still wants a prompt (e.g. "are
  // you sure?"). Does not change request method; GET remains GET.
  document.addEventListener("click", function (event) {
    const link = event.target.closest && event.target.closest("a[data-turbo-confirm]");
    if (!link) return;
    const message = link.dataset.turboConfirm;
    if (message && !window.confirm(message)) {
      event.preventDefault();
    }
  });
})();
